import React, { createContext, useState, useEffect, useContext } from "react";
import { ExerciseSet } from "../pages/company/types";
import {
  getStoredAccessToken,
  storeTokens,
  clearTokens,
} from "../services/AuthService";

interface IAuthContext {
  isAuthenticated: boolean;
  loginUser: (accessToken: string, refreshToken: string) => void;
  logoutUser: () => void;
  accessToken: string | undefined;
  setAccessToken: (token: string) => void;
  wodSets: Array<ExerciseSet>;
  setWodSets: (sets: Array<ExerciseSet>) => void;
  exercises: Array<string>;
  setExercises: (exercises: Array<string>) => void;
}

const AuthContext = createContext<IAuthContext>({
  isAuthenticated: false,
  loginUser: () => {},
  logoutUser: () => {},
  accessToken: "",
  setAccessToken: () => {},
  wodSets: [],
  setWodSets: () => {},
  exercises: [],
  setExercises: () => {},
});

export const useAuth = (): IAuthContext => useContext(AuthContext);

export const AuthProvider = ({ children }: { children: JSX.Element }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [accessToken, setAccessToken] = useState<string | undefined>(undefined);
  const [wodSets, setWodSets] = useState<Array<ExerciseSet>>([]);
  const [exercises, setExercises] = useState<Array<string>>([]);

  const loginUser = (token: string, refresh: string): void => {
    storeTokens(token, refresh);
    setAccessToken(token);
    setIsAuthenticated(true);
  };

  const logoutUser = (): void => {
    clearTokens();
    setIsAuthenticated(false);
    setAccessToken(undefined);
  };

  useEffect(() => {
    const token = getStoredAccessToken();
    if (token) {
      setAccessToken(token);
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        accessToken,
        setAccessToken,
        loginUser,
        logoutUser,
        wodSets,
        setWodSets,
        setExercises,
        exercises,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
